// extracted by mini-css-extract-plugin
module.exports = {"pillWrapper":"PlanPill_pillWrapper__25Cla","pillWrapperNone":"PlanPill_pillWrapperNone__2Bbv7","pillText":"PlanPill_pillText__1Mss9"};